// "Is this async result still current?" A capture stays current until its
// request scope (or any parent) advances.
export interface RequestScope {
  capture(): () => boolean;
}

export interface MutableRequestScope extends RequestScope {
  // Invalidates every earlier capture.
  advance(): void;
}

export function createRequestScope(parent?: RequestScope): MutableRequestScope {
  let counter = 0;
  return {
    capture: () => {
      const seen = counter;
      const parentCurrent = parent ? parent.capture() : () => true;
      return () => seen === counter && parentCurrent();
    },
    advance: () => {
      counter += 1;
    },
  };
}
